export default __webpack_public_path__ + "static/media/feedback-good-white.833d4dcc.png";